<template>
  <el-form
    ref="userFormRef"
    :model="userForm"
    :rules="rules"
    label-width="120px"
    class="mainSearch"
    style="padding-top:60px;height:100%;"
  >
    <el-form-item label="旧密码" prop="oldpassword">
      <el-input
        v-model.trim="userForm.oldpassword"
        type="password"
        show-password
        placeholder="请输入旧密码"
      ></el-input>
    </el-form-item>
    <el-form-item label="新密码" prop="password">
      <el-input
        v-model.trim="userForm.password"
        type="password"
        show-password
        placeholder="请输入密码"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="确认密码"
      prop="confirmPassword"
    >
      <el-input
        v-model.trim="userForm.confirmPassword"
        type="password"
        show-password
        placeholder="请输入确认密码"
      ></el-input>
    </el-form-item>
    <el-form-item>
        <el-button type="danger" :loading="loading" @click="doUserSave">{{
          loading ? "提交中 ..." : "修改密码"
        }}</el-button>
    </el-form-item>
  </el-form>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { changePassword } from "@/api/user";

let timer;

const loading = ref(false);

let userFormRef = ref();

//onMounted方法
onMounted(() => {});

//用户表单项
let userForm = ref({
  userid: null,
  oldpassword:"",
  password: "",
  confirmPassword: "",
});

//保存用户数据
const doUserSave = () => {
  userFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }
    changePassword(userForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
            ElMessage({
                message: res.data.msg,
                type: 'success'
            });
            clearTimeout(timer);
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//密码验证规则
const validatePass = (rule, value, callback) => {
  //  密码只能由大小写英文字母或数字开头，且由大小写英文字母_.组成
  const reg =
    /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/;
  if (!value.match(reg)) {
    callback(
      new Error("密码长度不小于8位，必须包含大写、小写数字、字符中至少3种")
    );
  } else {
    callback();
  }
};
const validatePass2 = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入确认密码"));
  } else if (value !== userForm.value.password) {
    callback(new Error("两次输入的密码不一致"));
  } else {
    callback();
  }
};

//用户表单验证规则
const rules = ref({
  oldpassword: [
    { required: true, message: "旧密码不能为空", trigger: "blur" },
    { min: 8, max: 16, message: "密码位数只能在8~16之间", trigger: "blur" },
    { required: true, validator: validatePass, trigger: "blur" },
  ],
  password: [
    { required: true, message: "新密码不能为空", trigger: "blur" },
    { min: 8, max: 16, message: "密码位数只能在8~16之间", trigger: "blur" },
    { required: true, validator: validatePass, trigger: "blur" },
  ],
  confirmPassword: [
    { required: true, message: "确认密码不能为空", trigger: "blur" },
    { min: 8, max: 16, message: "密码位数只能在8~16之间", trigger: "blur" },
    { required: true, validator: validatePass2, trigger: "blur" },
  ],
});
</script>